<template>
  <b-row>
    <b-col md="12">
      <div>
        <table relative class="table b-table" :class="listCertificates.length ? 'b-table-selectable b-table-select-single' : ''">
          <thead role="rowgroup">
            <tr role="row">
              <th role="columnheader" class="text-center table-condensed-ipad">{{$t('common.security.cert_name') }}</th>
              <th role="columnheader" v-if="canEdit" class="text-center table-condensed-ipad col-1">{{ $t('rights.edit') }}</th>
              <th role="columnheader" v-if="canDelete" class="text-center table-condensed-ipad col-1">{{ $t('rights.delete') }}</th>
            </tr>
          </thead>
          <tbody role="rowgroup">
            <tr role="row" v-if="activateSpinner">
              <td role="cell" colspan="3" class="text-center py-0">
                <spinner class=""></spinner>
              </td>
            </tr>
            <tr role="row" v-else-if="listCertificates.length" v-for="(certificate, index) in listCertificates" :key="'certificate-'+index" @click="actionDetails($event, certificate.id)">
              <td role="cell" class="text-center">{{certificate.name}}</td>
              <td role="cell" v-if="canEdit"  class="text-center" @click="actionEdit($event, certificate.id)"><i class="fa-regular fa-pencil"></i></td>
              <td role="cell" v-if="canDelete"  class="text-center" @click="actionDelete($event, certificate.id)"><i class="fa-regular fa-trash"></i></td>
            </tr>
            <tr role="row" v-else class="no-hover">
              <td role="cell" colspan="3" class="text-center font-weight-bold">
                {{ $t('common.security.no_result') }}
              </td>
            </tr>
          </tbody>
        </table>
        <b-row class="justify-content-end mt-4 no-gutter" v-if="canAdd">
          <b-button variant="primary" @click="actionAdd">
            <span class="d-none d-xl-inline">{{ $t('common.security.add_cert') }}</span>
          </b-button>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>

import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'CertificatesList',
  components: {
    'spinner': Spinner
  },
  props: {
  },
  computed: {
    canAdd () {
      return this.$engine.firstOn().rights.rightIs('certificate_add', true)
    },
    canEdit () {
      return this.$engine.firstOn().rights.rightIs('certificate_edit', true)
    },
    canDelete () {
      return this.$engine.firstOn().rights.rightIs('certificate_delete', true)
    }
  },
  data () {
    return {
      activateSpinner: false,
      listCertificates: []
    }
  },
  created () {
    this.listCertificates = [
      {
        id: 1,
        name: 'Certificate 1'
      },
      {
        id: 2,
        name: 'Certificate 2'
      },
      {
        id: 3,
        name: 'Certificate 3'
      },
      {
        id: 4,
        name: 'Certificate 4'
      },
    ]
  },
  methods: {
    actionAdd () {
      loadPage(this, { url: '/security/certificate/add/-1'})
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
    },
    actionDetails ($e, id) {
      loadPage(this, { url: '/security/certificate/view/' + id })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      loadPage(this, { url: '/security/certificate/edit/' + id })
    },
    getMessageRouting () {
      let that = this
      this.$engine.firstOn().security.certificates.fetch()({
      })
      .then(resp => {
        let messageRouting = {}
        messageRouting = resp.data.MessageRouting
        this.updateMessages(messageRouting)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    updateMessages(messageRouting){
      this.messageConfigList = messageRouting
    },
  }
}

</script>
